/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Packing_List_UnitsInputs */

const en_inbound_field_packing_list_units = /** @type {(inputs: Inbound_Field_Packing_List_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Units of the packing list`)
};

/**
* | output |
* | --- |
* | "Units of the packing list" |
*
* @param {Inbound_Field_Packing_List_UnitsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_packing_list_units = /** @type {((inputs?: Inbound_Field_Packing_List_UnitsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Packing_List_UnitsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_packing_list_units(inputs)
});